export const filterData = {
  'show-all': {
    icon: 'i-bolt tw-opacity-0',
    hideIcon: true,
  },
  todos: {
    icon: 'i-bolt tw-text-sf-success-light-1',
    hideIcon: false,
  },
  checks: {
    icon: 'i-square tw-text-sf-primary',
    hideIcon: false,
  },
  unreconciled: {
    icon: 'i-unreconciled sf-c-danger-light-1',
    hideIcon: false,
  },
  not_prepared: {
    icon: 'workflows/not_prepared.svg',
    hideIcon: false,
  },
  unreviewed_by_me: {
    icon: 'workflows/crossed_check.svg',
    hideIcon: false,
  },
  prepared_unreviewed_by_me: {
    icon: 'workflows/prepared_unreviewed_by_me.svg',
    hideIcon: false,
  },
  starred: {
    icon: 'fa fa-star sf-c-warning-light-1',
    hideIcon: false,
  },
}
